module.exports = __webpack_public_path__ + "img/yiyao_longshenrongfa_suoluetu.6043ff63.png";